import React, { useEffect, useState, useCallback } from 'react';
import api from '../lib/api';
import { PageHeader, Card, Modal, StatCard } from '../components/ui';
import { Plus, Pencil, Trash2, HeartHandshake, Target, Users, TrendingUp, Download, ExternalLink, Gift, Mail, FileText, Receipt, QrCode, Megaphone, BarChart3, Webhook, Sparkles, HelpCircle, X, Info, Lightbulb, Quote, Cake, Rocket, Wallet, Coins } from 'lucide-react';

const idag = () => new Date().toISOString().slice(0, 10);
const SEDLER_MYNT = [1000, 500, 200, 100, 50, 20, 10, 5, 1];
const tomKollekt = () => ({
  dato: idag(), formaal: '', belop: '', valuta: 'NOK',
  teller1_navn: '', teller2_navn: '',
  konto: '3440', motkonto: '1900', notat: '',
  bruk_spesifikasjon: false,
  spesifikasjon: SEDLER_MYNT.reduce((o, d) => ({ ...o, [d]: '' }), {}),
});

const tomKamp = () => ({
  tittel: '', beskrivelse: '', mal_belop: 0, valuta: 'NOK',
  start_dato: '', slutt_dato: '', status: 'aktiv',
  bilde_url: '', offentlig: true, public_slug: '',
  konto: '3440', auto_bokfor: true, motkonto_default: '',
  stretch_mal: 0, matching_aktiv: false, matching_max: 0, matching_sponsor: '',
  allow_team: false, slack_webhook: '', takke_melding: '', vis_giverveggen: true,
  notat: '',
  // v35
  verifisert: false, innsamlingskontrollen: false, orgnr: '',
  transparens_url: '', bilder_extra: '', video_url: '',
  bursdag_modus: false, bursdag_navn: '', bursdag_dato: '',
  vipps_nummer: '',
});
const tomOppd = () => ({ tittel: '', tekst: '', bilde_url: '' });
const tomTesti = () => ({ navn: '', rolle: '', sitat: '', bilde_url: '' });
const tomPartner = () => ({ navn: '', logo_url: '', lenke: '', belop: 0 });
const tomDon = () => ({
  dato: new Date().toISOString().slice(0, 10),
  belop: 0, valuta: 'NOK', medlem_id: '',
  giver_navn: '', giver_epost: '', giver_telefon: '', giver_fnr: '',
  anonym: false, skattefradrag: false, metode: 'manuell',
  referanse: '', melding: '', frekvens: 'engangs',
  gave_navn: '', gave_melding: '',
});
const tomTeam = () => ({ navn: '', beskrivelse: '', bilde_url: '', mal_belop: 0, eier_navn: '', eier_epost: '' });
const tomMail = () => ({ emne: '', melding: '', test_til: '' });

const STATUSER = [
  { v: 'aktiv', t: 'Aktiv', cls: 'badge-success' },
  { v: 'lukket', t: 'Lukket', cls: 'badge-info' },
  { v: 'kladd', t: 'Kladd', cls: 'badge-warning' },
];

const Innsamling = () => {
  const [oversikt, setOversikt] = useState(null);
  const [liste, setListe] = useState(null);
  const [valgt, setValgt] = useState(null);
  const [donasjoner, setDonasjoner] = useState([]);
  const [openK, setOpenK] = useState(false);
  const [redK, setRedK] = useState(null);
  const [skjemaK, setSkjemaK] = useState(tomKamp());
  const [openD, setOpenD] = useState(false);
  const [skjemaD, setSkjemaD] = useState(tomDon());
  const [medlemmer, setMedlemmer] = useState([]);
  const [aar, setAar] = useState(new Date().getFullYear());
  const [teams, setTeams] = useState([]);
  const [openTeam, setOpenTeam] = useState(false);
  const [redTeam, setRedTeam] = useState(null);
  const [skjemaTeam, setSkjemaTeam] = useState(tomTeam());
  const [openMail, setOpenMail] = useState(false);
  const [skjemaMail, setSkjemaMail] = useState(tomMail());
  const [dash, setDash] = useState(null);
  const [openDash, setOpenDash] = useState(false);
  const [visHjelp, setVisHjelp] = useState(() => localStorage.getItem('fr_hjelp_skjult') !== '1');
  const [openVeileder, setOpenVeileder] = useState(false);
  // v35: oppdateringer / testimonials / partnere
  const [oppdater, setOppdater] = useState([]);
  const [testis, setTestis] = useState([]);
  const [partnere, setPartnere] = useState([]);
  const [openOppd, setOpenOppd] = useState(false);
  const [redOppd, setRedOppd] = useState(null);
  const [skjemaOppd, setSkjemaOppd] = useState(tomOppd());
  const [openTesti, setOpenTesti] = useState(false);
  const [redTesti, setRedTesti] = useState(null);
  const [skjemaTesti, setSkjemaTesti] = useState(tomTesti());
  const [openPartner, setOpenPartner] = useState(false);
  const [redPartner, setRedPartner] = useState(null);
  const [skjemaPartner, setSkjemaPartner] = useState(tomPartner());
  const [aiBusy, setAiBusy] = useState(false);
  // Kollekt / spontan innsamling
  const [kollekter, setKollekter] = useState([]);
  const [openKollekt, setOpenKollekt] = useState(false);
  const [skjemaKollekt, setSkjemaKollekt] = useState(tomKollekt());
  const [kollektBusy, setKollektBusy] = useState(false);

  const lastKollekter = useCallback(() => {
    api.get('/kollekt').then((r) => setKollekter(r.data)).catch(() => {});
  }, []);

  const apneKollekt = () => { setSkjemaKollekt(tomKollekt()); setOpenKollekt(true); };

  const spesSum = (spes) => SEDLER_MYNT.reduce(
    (sum, d) => sum + d * (parseInt(spes[d], 10) || 0), 0);

  const lagreKollekt = async () => {
    const s = skjemaKollekt;
    if (!s.formaal.trim()) { alert('Formål/anledning er påkrevd.'); return; }
    if (!s.teller1_navn.trim() || !s.teller2_navn.trim()) {
      alert('To tellere må oppgis for kontroll.'); return;
    }
    const belop = s.bruk_spesifikasjon ? spesSum(s.spesifikasjon) : parseFloat(String(s.belop).replace(',', '.'));
    if (!belop || belop <= 0) { alert('Beløp må være større enn 0.'); return; }
    setKollektBusy(true);
    try {
      await api.post('/kollekt', {
        dato: s.dato, formaal: s.formaal, belop, valuta: s.valuta,
        teller1_navn: s.teller1_navn, teller2_navn: s.teller2_navn,
        konto: s.konto, motkonto: s.motkonto, notat: s.notat,
        kontanttelling: s.bruk_spesifikasjon ? JSON.stringify(s.spesifikasjon) : '',
        bokfor: true,
      });
      setOpenKollekt(false);
      lastKollekter();
    } catch (e) {
      alert(e.response?.data?.error || 'Kunne ikke lagre kollekt.');
    } finally { setKollektBusy(false); }
  };

  const slettKollekt = async (x) => {
    if (!window.confirm(`Slette kollekt «${x.formaal}»?`)) return;
    try { await api.delete(`/kollekt/${x.id}`); lastKollekter(); }
    catch (e) { alert(e.response?.data?.error || 'Kunne ikke slette.'); }
  };

  const skjulHjelp = () => { localStorage.setItem('fr_hjelp_skjult', '1'); setVisHjelp(false); };

  const lastListe = useCallback(() => {
    api.get('/kampanjer').then((r) => setListe(r.data));
    api.get('/fundraising/oversikt').then((r) => setOversikt(r.data));
  }, []);
  const lastDonasjoner = useCallback((kid) => {
    api.get(`/kampanjer/${kid}/donasjoner`).then((r) => setDonasjoner(r.data));
  }, []);

  useEffect(() => { lastListe(); }, [lastListe]);
  useEffect(() => { lastKollekter(); }, [lastKollekter]);

  const apneK = (k) => {
    setRedK(k);
    setSkjemaK(k ? { ...tomKamp(), ...k } : tomKamp());
    setOpenK(true);
  };  const lagreK = async () => {
    if (!skjemaK.tittel.trim()) { alert('Tittel er påkrevd.'); return; }
    if (redK) await api.put(`/kampanjer/${redK.id}`, skjemaK);
    else await api.post('/kampanjer', skjemaK);
    setOpenK(false); lastListe();
    if (valgt && redK && redK.id === valgt.id) {
      const r = await api.get(`/kampanjer/${valgt.id}`); setValgt(r.data);
    }
  };
  const slettK = async (k) => {
    if (!window.confirm(`Slette kampanjen «${k.tittel}» og alle donasjoner?`)) return;
    await api.delete(`/kampanjer/${k.id}`);
    if (valgt?.id === k.id) setValgt(null);
    lastListe();
  };
  const velgK = async (k) => {
    const r = await api.get(`/kampanjer/${k.id}`);
    setValgt(r.data);
    lastDonasjoner(k.id);
    try { const t = await api.get(`/kampanjer/${k.id}/teams`); setTeams(t.data); }
    catch { setTeams([]); }
    try { const o = await api.get(`/kampanjer/${k.id}/oppdateringer`); setOppdater(o.data); }
    catch { setOppdater([]); }
    try { const t2 = await api.get(`/kampanjer/${k.id}/testimonials`); setTestis(t2.data); }
    catch { setTestis([]); }
    try { const p = await api.get(`/kampanjer/${k.id}/partnere`); setPartnere(p.data); }
    catch { setPartnere([]); }
  };

  // v35 handlers
  const apneOppd = (o) => { setRedOppd(o); setSkjemaOppd(o ? { ...tomOppd(), ...o } : tomOppd()); setOpenOppd(true); };
  const lagreOppd = async () => {
    if (!skjemaOppd.tittel.trim()) { alert('Tittel påkrevd.'); return; }
    if (redOppd) await api.put(`/oppdateringer/${redOppd.id}`, skjemaOppd);
    else await api.post(`/kampanjer/${valgt.id}/oppdateringer`, skjemaOppd);
    setOpenOppd(false);
    const r = await api.get(`/kampanjer/${valgt.id}/oppdateringer`); setOppdater(r.data);
  };
  const slettOppd = async (o) => {
    if (!window.confirm(`Slette oppdatering «${o.tittel}»?`)) return;
    await api.delete(`/oppdateringer/${o.id}`);
    const r = await api.get(`/kampanjer/${valgt.id}/oppdateringer`); setOppdater(r.data);
  };
  const apneTesti = (t) => { setRedTesti(t); setSkjemaTesti(t ? { ...tomTesti(), ...t } : tomTesti()); setOpenTesti(true); };
  const lagreTesti = async () => {
    if (!skjemaTesti.sitat.trim()) { alert('Sitat påkrevd.'); return; }
    if (redTesti) await api.put(`/testimonials/${redTesti.id}`, skjemaTesti);
    else await api.post(`/kampanjer/${valgt.id}/testimonials`, skjemaTesti);
    setOpenTesti(false);
    const r = await api.get(`/kampanjer/${valgt.id}/testimonials`); setTestis(r.data);
  };
  const slettTesti = async (t) => {
    if (!window.confirm('Slette dette sitatet?')) return;
    await api.delete(`/testimonials/${t.id}`);
    const r = await api.get(`/kampanjer/${valgt.id}/testimonials`); setTestis(r.data);
  };
  const apnePartner = (p) => { setRedPartner(p); setSkjemaPartner(p ? { ...tomPartner(), ...p } : tomPartner()); setOpenPartner(true); };
  const lagrePartner = async () => {
    if (!skjemaPartner.navn.trim()) { alert('Navn påkrevd.'); return; }
    if (redPartner) await api.put(`/partnere/${redPartner.id}`, skjemaPartner);
    else await api.post(`/kampanjer/${valgt.id}/partnere`, skjemaPartner);
    setOpenPartner(false);
    const r = await api.get(`/kampanjer/${valgt.id}/partnere`); setPartnere(r.data);
  };
  const slettPartner = async (p) => {
    if (!window.confirm(`Slette partner «${p.navn}»?`)) return;
    await api.delete(`/partnere/${p.id}`);
    const r = await api.get(`/kampanjer/${valgt.id}/partnere`); setPartnere(r.data);
  };
  const aiForslagTakk = async () => {
    setAiBusy(true);
    try {
      const r = await api.post(`/kampanjer/${valgt?.id || redK?.id || 0}/ai-takke-melding`);
      if (r.data?.melding) setSkjemaK({ ...skjemaK, takke_melding: r.data.melding });
    } catch (e) {
      alert(e?.response?.data?.error || 'AI-forslag feilet (krever OPENAI_API_KEY).');
    } finally { setAiBusy(false); }
  };
  const lastNedLonnstrekk = async () => {
    try {
      const r = await api.get(`/fundraising/lonnstrekk/${aar}.csv`, { responseType: 'blob' });
      const url = URL.createObjectURL(r.data);
      const a = document.createElement('a');
      a.href = url; a.download = `lonnstrekk-${aar}.csv`;
      document.body.appendChild(a); a.click(); a.remove();
      URL.revokeObjectURL(url);
    } catch (e) { alert('Kunne ikke hente lønnstrekk-CSV.'); }
  };

  const apneD = () => { setSkjemaD(tomDon()); setOpenD(true); };
  const lagreD = async () => {
    if (Number(skjemaD.belop) <= 0) { alert('Beløp må være større enn 0.'); return; }
    const payload = { ...skjemaD };
    if (!payload.medlem_id) delete payload.medlem_id;
    await api.post(`/kampanjer/${valgt.id}/donasjoner`, payload);
    setOpenD(false); velgK(valgt); lastListe();
  };
  const slettD = async (x) => {
    if (!window.confirm(`Slett donasjonen på ${x.belop} kr?`)) return;
    await api.delete(`/donasjoner/${x.id}`);
    velgK(valgt); lastListe();
  };
  const bokforD = async (x) => {
    try {
      const r = await api.post(`/donasjoner/${x.id}/bokfor`);
      alert(r.data.info || `Bokført som bilag #${r.data.bilag_id}.`);
      velgK(valgt);
    } catch (e) { alert(e?.response?.data?.error || 'Bokføring feilet.'); }
  };
  const sendKvitt = async (x) => {
    try {
      const r = await api.post(`/donasjoner/${x.id}/send-kvittering`);
      alert(`Kvittering sendt til ${r.data.til}.`);
      velgK(valgt);
    } catch (e) { alert(e?.response?.data?.error || 'Sending feilet.'); }
  };
  const visKvitt = (x) => {
    window.open(`/api/donasjoner/${x.id}/kvittering.html`, '_blank');
  };
  const apneNyMedHent = async () => {
    if (!medlemmer.length) {
      try { const r = await api.get('/medlemmer/lookup'); setMedlemmer(r.data); } catch {}
    }
    apneD();
  };
  const valgMedlem = (id) => {
    const m = medlemmer.find((x) => String(x.id) === String(id));
    if (m) setSkjemaD({ ...skjemaD, medlem_id: m.id, giver_navn: m.navn, giver_epost: m.epost });
    else setSkjemaD({ ...skjemaD, medlem_id: '' });
  };
  const lastNedCsv = async () => {
    const r = await api.get(`/kampanjer/${valgt.id}/donasjoner.csv`, { responseType: 'blob' });
    const url = URL.createObjectURL(r.data);
    const a = document.createElement('a');
    a.href = url; a.download = `kampanje-${valgt.id}-donasjoner.csv`;
    document.body.appendChild(a); a.click(); a.remove();
    URL.revokeObjectURL(url);
  };
  const lastNedGaverapport = async () => {
    try {
      const r = await api.get(`/fundraising/gaverapport/${aar}.csv`, { responseType: 'blob' });
      const url = URL.createObjectURL(r.data);
      const a = document.createElement('a');
      a.href = url; a.download = `gaverapport-${aar}.csv`;
      document.body.appendChild(a); a.click(); a.remove();
      URL.revokeObjectURL(url);
    } catch (e) { alert('Kunne ikke hente rapport.'); }
  };

  // Plakat / share / embed
  const apneBlob = async (url) => {
    try {
      const r = await api.get(url, { responseType: 'blob' });
      const blobUrl = URL.createObjectURL(new Blob([r.data], { type: 'text/html' }));
      window.open(blobUrl, '_blank');
      setTimeout(() => URL.revokeObjectURL(blobUrl), 60000);
    } catch (e) {
      alert(e?.response?.data?.error || 'Kunne ikke åpne rapport.');
    }
  };
  const apnePlakat = () => apneBlob(`/kampanjer/${valgt.id}/plakat.html`);
  const apneInnsamlingsrapport = () => apneBlob(`/fundraising/innsamlingskontrollen/${aar}.html`);
  const apneSkattefradrag = (medlemId) => {
    if (!medlemId) return;
    apneBlob(`/fundraising/skattefradrag/${aar}/giver/${medlemId}.html`);
  };
  const apneDashboard = async () => {
    try {
      const r = await api.get(`/fundraising/dashboard?aar=${aar}`);
      setDash(r.data); setOpenDash(true);
    } catch { alert('Kunne ikke laste dashboard.'); }
  };
  const kopierLenke = (url) => {
    navigator.clipboard.writeText(url);
    alert('Kopiert til utklippstavle:\n' + url);
  };
  const visEmbed = () => {
    const base = window.location.origin;
    const url = `${base}/api/public/kampanje/${valgt.public_slug}/widget.html`;
    const code = `<iframe src="${url}" width="320" height="220" frameborder="0" style="border:none"></iframe>`;
    window.prompt('Lim inn følgende kode på din nettside:', code);
  };
  const testSlack = async () => {
    try { await api.post(`/kampanjer/${valgt.id}/notify-slack-test`); alert('Test sendt – sjekk Slack/Discord.'); }
    catch (e) { alert(e?.response?.data?.error || 'Test feilet.'); }
  };

  // Teams
  const apneTeam = (t) => {
    setRedTeam(t);
    setSkjemaTeam(t ? { ...tomTeam(), ...t } : tomTeam());
    setOpenTeam(true);
  };
  const lagreTeam = async () => {
    if (!skjemaTeam.navn.trim()) { alert('Navn er påkrevd.'); return; }
    if (redTeam) await api.put(`/teams/${redTeam.id}`, skjemaTeam);
    else await api.post(`/kampanjer/${valgt.id}/teams`, skjemaTeam);
    setOpenTeam(false);
    const t = await api.get(`/kampanjer/${valgt.id}/teams`); setTeams(t.data);
  };
  const slettTeam = async (t) => {
    if (!window.confirm(`Slett teamet «${t.navn}»?`)) return;
    await api.delete(`/teams/${t.id}`);
    const r = await api.get(`/kampanjer/${valgt.id}/teams`); setTeams(r.data);
  };

  // Mail-kampanje
  const apneMail = () => { setSkjemaMail({ ...tomMail(), emne: `Bli med å støtte ${valgt.tittel}` }); setOpenMail(true); };
  const sendMail = async (testMode) => {
    if (!skjemaMail.emne.trim() || !skjemaMail.melding.trim()) { alert('Emne og melding er påkrevd.'); return; }
    const payload = { ...skjemaMail };
    if (!testMode) payload.test_til = '';
    if (testMode && !payload.test_til.trim()) { alert('Oppgi test-e-post.'); return; }
    try {
      const r = await api.post(`/kampanjer/${valgt.id}/mailkampanje`, payload);
      alert(`Sendt: ${r.data.sendt} / ${r.data.total}${r.data.feilet ? ` (feilet: ${r.data.feilet})` : ''}`);
      if (!testMode) setOpenMail(false);
    } catch (e) { alert(e?.response?.data?.error || 'Sending feilet.'); }
  };

  const fmt = (n) => Number(n || 0).toLocaleString('nb-NO', { minimumFractionDigits: 0, maximumFractionDigits: 2 });
  const sb = STATUSER.find((s) => s.v === (valgt?.status || 'aktiv')) || STATUSER[0];

  if (!liste) return <span className="fm-text-muted">Laster…</span>;

  return (
    <>
      <PageHeader
        title="Innsamling & fundraising"
        subtitle="Drift kampanjer, registrer donasjoner og følg fremdriften mot mål."
        actions={
          <div style={{ display: 'flex', gap: 6, alignItems: 'center', flexWrap: 'wrap' }}>
            <input type="number" className="input" style={{ width: 80 }}
              value={aar} onChange={(e) => setAar(e.target.value)} title="År for rapporter" />
            <button className="btn btn-secondary" onClick={apneDashboard} title="Giver-dashboard">
              <BarChart3 size={14} /> Dashboard
            </button>
            <button className="btn btn-secondary" onClick={lastNedGaverapport} title="Skatteetaten gaverapport">
              <Download size={14} /> Gaverapport
            </button>
            <button className="btn btn-secondary" onClick={lastNedLonnstrekk} title="Lønnstrekk-CSV til arbeidsgivere">
              <Download size={14} /> Lønnstrekk
            </button>
            <button className="btn btn-secondary" onClick={apneInnsamlingsrapport} title="Innsamlingskontrollen-rapport">
              <FileText size={14} /> Innsamlingskontroll
            </button>
            <button className="btn btn-secondary" onClick={() => setOpenVeileder(true)} title="Slik kommer du i gang">
              <HelpCircle size={14} /> Veileder
            </button>
            <button className="btn btn-secondary" onClick={apneKollekt} title="Registrer spontan kollekt / kontantinnsamling">
              <Coins size={14} /> Registrer kollekt
            </button>
            <button className="btn btn-primary" onClick={() => apneK(null)}>
              <Plus size={16} /> Ny kampanje
            </button>
          </div>
        }
      />

      {visHjelp && (
        <div style={{ position: 'relative', background: 'linear-gradient(135deg, #eef2ff, #faf5ff)', border: '1px solid #c7d2fe', borderRadius: 10, padding: 14, marginBottom: 14, color: '#1e293b' }}>
          <button onClick={skjulHjelp} title="Skjul"
            style={{ position: 'absolute', top: 8, right: 8, background: 'transparent', border: 'none', cursor: 'pointer', color: '#64748b' }}>
            <X size={16} />
          </button>
          <div style={{ display: 'flex', gap: 10, alignItems: 'flex-start' }}>
            <Lightbulb size={20} color="#7c3aed" style={{ flexShrink: 0, marginTop: 2 }} />
            <div style={{ fontSize: 14, lineHeight: 1.5 }}>
              <b>Kom i gang med innsamling på 3 trinn:</b>
              <ol style={{ margin: '6px 0 0', paddingLeft: 20 }}>
                <li>Klikk <b>Ny kampanje</b> og fyll inn tittel, beskrivelse og mål. Last opp et bilde for høyere konvertering.</li>
                <li>Hak av <b>Vekst-funksjoner</b> som matching, stretch-mål, team og takke-melding for å øke engasjementet.</li>
                <li>Bruk knappene <b>QR-plakat</b>, <b>Embed-widget</b>, <b>Del-lenke</b> og <b>E-postkampanje</b> for å promotere giversiden.</li>
              </ol>
              <div style={{ marginTop: 6, color: '#475569', fontSize: 13 }}>
                Klikk <i>Veileder</i> oppe til høyre for full gjennomgang. <span onClick={skjulHjelp} style={{ cursor: 'pointer', textDecoration: 'underline' }}>Skjul denne meldingen</span>.
              </div>
            </div>
          </div>
        </div>
      )}

      {oversikt && (
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: 12, marginBottom: 16 }}>
          <StatCard label="Aktive kampanjer" value={oversikt.antall_aktive} icon={HeartHandshake} />
          <StatCard label="Kampanjer totalt" value={oversikt.antall_kampanjer} icon={Target} />
          <StatCard label="Donasjoner" value={oversikt.antall_donasjoner} icon={Gift} />
          <StatCard label="Samlet inn" value={`${fmt(oversikt.samlet_belop)} kr`} icon={TrendingUp} />
        </div>
      )}

      <Card style={{ marginBottom: 16 }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 8 }}>
          <div>
            <h3 style={{ margin: 0, display: 'flex', alignItems: 'center', gap: 6 }}>
              <Coins size={18} /> Kollekt / spontan innsamling
            </h3>
            <p className="fm-text-muted" style={{ fontSize: 12, margin: '2px 0 0' }}>
              Registrer kontantinnsamling som ikke er knyttet til en kampanje – f.eks. kollekt
              etter gudstjeneste eller innsamling etter et arrangement. To tellere kreves for kontroll.
            </p>
          </div>
          <button className="btn btn-primary" onClick={apneKollekt}>
            <Plus size={14} /> Registrer kollekt
          </button>
        </div>
        {kollekter.length > 0 && (
          <div style={{ overflowX: 'auto', marginTop: 12 }}>
            <table className="fm-table" style={{ fontSize: 13 }}>
              <thead><tr>
                <th>Dato</th><th>Formål</th><th style={{ textAlign: 'right' }}>Beløp</th>
                <th>Tellere</th><th>Bokført</th><th></th>
              </tr></thead>
              <tbody>
                {kollekter.map((x) => (
                  <tr key={x.id}>
                    <td>{x.dato}</td>
                    <td><b>{x.formaal}</b>{x.notat ? <div className="fm-text-muted" style={{ fontSize: 11 }}>{x.notat}</div> : null}</td>
                    <td style={{ textAlign: 'right', fontWeight: 600 }}>{fmt(x.belop)} kr</td>
                    <td style={{ fontSize: 12 }}>{x.teller1_navn} / {x.teller2_navn}</td>
                    <td>{x.bokfort
                      ? <span className="badge badge-success" style={{ fontSize: 10 }}>Bilag #{x.bilag_id}</span>
                      : <span className="badge" style={{ fontSize: 10 }}>Nei</span>}</td>
                    <td>
                      <button className="btn btn-ghost" onClick={() => apneBlob(`/kollekt/${x.id}/telleseddel.html`)} title="Skriv ut telleseddel med signaturfelt">
                        <FileText size={13} />
                      </button>
                      <button className="btn btn-ghost" onClick={() => slettKollekt(x)} title="Slett">
                        <Trash2 size={13} />
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </Card>

      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1.2fr', gap: 16 }}>
        <Card>
          <h3 style={{ marginTop: 0 }}>Kampanjer</h3>
          {liste.length === 0 ? (
            <div style={{ textAlign: 'center', padding: '24px 8px' }}>
              <HeartHandshake size={48} color="#a78bfa" style={{ marginBottom: 10 }} />
              <p className="fm-text-muted" style={{ marginBottom: 12 }}>
                Ingen kampanjer enda. Lag din første nå – det tar under et minutt.
              </p>
              <button className="btn btn-primary" onClick={() => apneK(null)}>
                <Plus size={16} /> Opprett din første kampanje
              </button>
              <p style={{ fontSize: 12, color: '#9ca3af', marginTop: 12 }}>
                Tips: Trenger du inspirasjon? Klikk <b>Veileder</b> øverst for steg-for-steg.
              </p>
            </div>
          ) : (
            <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
              {liste.map((k) => {
                const sb = STATUSER.find((s) => s.v === k.status) || STATUSER[0];
                const aktiv = valgt?.id === k.id;
                return (
                  <div
                    key={k.id}
                    onClick={() => velgK(k)}
                    style={{
                      padding: 12, borderRadius: 8, cursor: 'pointer',
                      border: aktiv ? '2px solid var(--theme-accent)' : '1px solid var(--theme-border)',
                      background: aktiv ? 'var(--theme-bg-soft)' : 'transparent',
                    }}
                  >
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline' }}>
                      <strong>{k.tittel}</strong>
                      <span className={`badge ${sb.cls}`}>{sb.t}</span>
                    </div>
                    <div className="fm-text-muted" style={{ fontSize: 13, marginTop: 2 }}>
                      {fmt(k.samlet_belop)} kr av {k.mal_belop > 0 ? `${fmt(k.mal_belop)} kr` : 'fritt'} ·
                      {' '}{k.antall_donasjoner} donasjoner
                    </div>
                    {k.mal_belop > 0 && (
                      <div style={{ marginTop: 6, height: 6, borderRadius: 3, background: 'var(--theme-border)', overflow: 'hidden' }}>
                        <div style={{
                          width: `${k.mal_prosent}%`, height: '100%',
                          background: 'var(--theme-accent)',
                        }} />
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          )}
        </Card>

        <Card>
          {!valgt ? (
            <p className="fm-text-muted" style={{ marginTop: 0 }}>Velg en kampanje til venstre for detaljer og donasjoner.</p>
          ) : (
            <>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: 8 }}>
                <div>
                  <h3 style={{ marginTop: 0, marginBottom: 4 }}>
                    {valgt.tittel} <span className={`badge ${sb.cls}`} style={{ marginLeft: 6 }}>{sb.t}</span>
                  </h3>
                  {valgt.beskrivelse && <p className="fm-text-muted" style={{ marginTop: 0 }}>{valgt.beskrivelse}</p>}
                </div>
                <div style={{ display: 'flex', gap: 6 }}>
                  <button className="btn btn-secondary" onClick={() => apneK(valgt)}><Pencil size={14} /></button>
                  <button className="btn btn-secondary" onClick={() => slettK(valgt)}><Trash2 size={14} /></button>
                </div>
              </div>

              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(140px, 1fr))', gap: 8, marginTop: 12 }}>
                <div><b>{fmt(valgt.samlet_belop)} kr</b><div className="fm-text-muted" style={{ fontSize: 12 }}>Samlet inn</div></div>
                <div><b>{valgt.mal_belop > 0 ? `${fmt(valgt.mal_belop)} kr` : '—'}</b><div className="fm-text-muted" style={{ fontSize: 12 }}>Mål</div></div>
                <div><b>{valgt.antall_donasjoner}</b><div className="fm-text-muted" style={{ fontSize: 12 }}>Donasjoner</div></div>
                <div><b>{valgt.antall_givere}</b><div className="fm-text-muted" style={{ fontSize: 12 }}>Givere</div></div>
              </div>

              {valgt.mal_belop > 0 && (
                <div style={{ marginTop: 12 }}>
                  <div style={{ height: 10, borderRadius: 5, background: 'var(--theme-border)', overflow: 'hidden' }}>
                    <div style={{
                      width: `${valgt.mal_prosent}%`, height: '100%',
                      background: 'var(--theme-accent)', transition: 'width 0.4s',
                    }} />
                  </div>
                  <div className="fm-text-muted" style={{ fontSize: 12, marginTop: 4 }}>
                    {valgt.mal_prosent}% av målet
                  </div>
                </div>
              )}

              {valgt.offentlig && valgt.public_slug && (
                <div style={{ marginTop: 12, padding: 10, background: 'var(--theme-bg-soft)', borderRadius: 6, fontSize: 13 }}>
                  <ExternalLink size={14} style={{ verticalAlign: 'middle' }} /> Offentlig giverside:
                  {' '}<code>/gi/{valgt.public_slug}</code>
                </div>
              )}
              {/* Verktøy-knappestripe */}
              {valgt.offentlig && valgt.public_slug && (
                <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap', marginTop: 12 }}>
                  <button className="btn btn-secondary" onClick={apnePlakat}>
                    <QrCode size={14} /> Plakat (QR)
                  </button>
                  <button className="btn btn-secondary" onClick={visEmbed}>
                    <Sparkles size={14} /> Embed-widget
                  </button>
                  <button className="btn btn-secondary"
                    onClick={() => kopierLenke(`${window.location.origin}/gi/${valgt.public_slug}/share`)}>
                    <ExternalLink size={14} /> Del-lenke (OG)
                  </button>
                  <button className="btn btn-secondary" onClick={apneMail}>
                    <Megaphone size={14} /> E-postkampanje
                  </button>
                  {valgt.slack_webhook && (
                    <button className="btn btn-secondary" onClick={testSlack}>
                      <Webhook size={14} /> Test Slack
                    </button>
                  )}
                </div>
              )}

              {/* Team-seksjon (peer-to-peer) */}
              {valgt.allow_team && (
                <>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: 16, marginBottom: 8 }}>
                    <h4 style={{ margin: 0 }}>Team / spleis-grupper</h4>
                    <button className="btn btn-primary" onClick={() => apneTeam(null)}>
                      <Plus size={14} /> Nytt team
                    </button>
                  </div>
                  {teams.length === 0 ? (
                    <p className="fm-text-muted">Ingen team enda. Opprett ett for å la givere samle inn på vegne av kampanjen.</p>
                  ) : (
                    <div style={{ overflowX: 'auto' }}>
                      <table className="fm-table">
                        <thead><tr><th>Navn</th><th>Eier</th>
                          <th style={{ textAlign: 'right' }}>Samlet</th>
                          <th style={{ textAlign: 'right' }}>Mål</th>
                          <th>Lenke</th><th></th></tr></thead>
                        <tbody>
                          {teams.map((t) => (
                            <tr key={t.id}>
                              <td><b>{t.navn}</b></td>
                              <td>{t.eier_navn || <i className="fm-text-muted">–</i>}</td>
                              <td style={{ textAlign: 'right' }}>{fmt(t.samlet_belop)} kr</td>
                              <td style={{ textAlign: 'right' }}>{t.mal_belop ? `${fmt(t.mal_belop)} kr` : '–'}</td>
                              <td><code style={{ fontSize: 11 }}>/gi/{valgt.public_slug}/team/{t.slug}</code></td>
                              <td style={{ whiteSpace: 'nowrap' }}>
                                <button className="btn btn-ghost" onClick={() =>
                                  kopierLenke(`${window.location.origin}/gi/${valgt.public_slug}/team/${t.slug}`)}>
                                  <ExternalLink size={14} />
                                </button>
                                <button className="btn btn-ghost" onClick={() => apneTeam(t)}><Pencil size={14} /></button>
                                <button className="btn btn-ghost" onClick={() => slettTeam(t)}><Trash2 size={14} /></button>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  )}
                </>
              )}
              {/* v35: Oppdateringer */}
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: 16, marginBottom: 8 }}>
                <h4 style={{ margin: 0, display: 'flex', alignItems: 'center', gap: 6 }}><Megaphone size={16} /> Oppdateringer</h4>
                <button className="btn btn-primary" onClick={() => apneOppd(null)}>
                  <Plus size={14} /> Ny oppdatering
                </button>
              </div>
              {oppdater.length === 0 ? (
                <p className="fm-text-muted">Ingen oppdateringer enda. Hold giverne dine engasjert med jevnlige oppdateringer!</p>
              ) : (
                <div style={{ overflowX: 'auto' }}>
                  <table className="fm-table">
                    <thead><tr><th>Tittel</th><th>Tekst</th><th>Publisert</th><th></th></tr></thead>
                    <tbody>
                      {oppdater.map((o) => (
                        <tr key={o.id}>
                          <td><b>{o.tittel}</b></td>
                          <td>{(o.tekst || '').slice(0, 100)}{(o.tekst || '').length > 100 ? '…' : ''}</td>
                          <td style={{ fontSize: 12 }}>{(o.publisert || '').slice(0, 10)}</td>
                          <td style={{ whiteSpace: 'nowrap' }}>
                            <button className="btn btn-ghost" onClick={() => apneOppd(o)}><Pencil size={14} /></button>
                            <button className="btn btn-ghost" onClick={() => slettOppd(o)}><Trash2 size={14} /></button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}

              {/* v35: Testimonials */}
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: 16, marginBottom: 8 }}>
                <h4 style={{ margin: 0, display: 'flex', alignItems: 'center', gap: 6 }}><Quote size={16} /> Sitater / Testimonials</h4>
                <button className="btn btn-primary" onClick={() => apneTesti(null)}>
                  <Plus size={14} /> Nytt sitat
                </button>
              </div>
              {testis.length === 0 ? (
                <p className="fm-text-muted">Ingen sitater. Legg til anbefalinger fra givere eller mottakere for å bygge tillit.</p>
              ) : (
                <div style={{ overflowX: 'auto' }}>
                  <table className="fm-table">
                    <thead><tr><th>Navn</th><th>Rolle</th><th>Sitat</th><th></th></tr></thead>
                    <tbody>
                      {testis.map((t) => (
                        <tr key={t.id}>
                          <td><b>{t.navn}</b></td>
                          <td>{t.rolle}</td>
                          <td><i>«{(t.sitat || '').slice(0, 100)}{(t.sitat || '').length > 100 ? '…' : ''}»</i></td>
                          <td style={{ whiteSpace: 'nowrap' }}>
                            <button className="btn btn-ghost" onClick={() => apneTesti(t)}><Pencil size={14} /></button>
                            <button className="btn btn-ghost" onClick={() => slettTesti(t)}><Trash2 size={14} /></button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}

              {/* v35: Partnere */}
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: 16, marginBottom: 8 }}>
                <h4 style={{ margin: 0, display: 'flex', alignItems: 'center', gap: 6 }}><HeartHandshake size={16} /> Bedriftspartnere</h4>
                <button className="btn btn-primary" onClick={() => apnePartner(null)}>
                  <Plus size={14} /> Ny partner
                </button>
              </div>
              {partnere.length === 0 ? (
                <p className="fm-text-muted">Ingen partnere registrert.</p>
              ) : (
                <div style={{ overflowX: 'auto' }}>
                  <table className="fm-table">
                    <thead><tr><th>Navn</th><th>Beløp</th><th>Lenke</th><th></th></tr></thead>
                    <tbody>
                      {partnere.map((p) => (
                        <tr key={p.id}>
                          <td><b>{p.navn}</b></td>
                          <td>{p.belop ? `${fmt(p.belop)} kr` : '–'}</td>
                          <td>{p.lenke ? <a href={p.lenke} target="_blank" rel="noopener noreferrer">Lenke</a> : '–'}</td>
                          <td style={{ whiteSpace: 'nowrap' }}>
                            <button className="btn btn-ghost" onClick={() => apnePartner(p)}><Pencil size={14} /></button>
                            <button className="btn btn-ghost" onClick={() => slettPartner(p)}><Trash2 size={14} /></button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: 16, marginBottom: 8 }}>
                <h4 style={{ margin: 0 }}>Donasjoner</h4>
                <div style={{ display: 'flex', gap: 6 }}>
                  <button className="btn btn-secondary" onClick={lastNedCsv} disabled={!donasjoner.length}>
                    <Download size={14} /> CSV
                  </button>
                  <button className="btn btn-primary" onClick={apneNyMedHent}>
                    <Plus size={14} /> Registrer
                  </button>
                </div>
              </div>

              {donasjoner.length === 0 ? (
                <p className="fm-text-muted">Ingen donasjoner registrert enda.</p>
              ) : (
                <div style={{ overflowX: 'auto' }}>
                  <table className="fm-table">
                    <thead>
                      <tr>
                        <th>Dato</th><th>Giver</th><th style={{ textAlign: 'right' }}>Beløp</th>
                        <th>Metode</th><th>Status</th><th></th>
                      </tr>
                    </thead>
                    <tbody>
                      {donasjoner.map((x) => (
                        <tr key={x.id}>
                          <td>{x.dato}</td>
                          <td>
                            {x.giver_navn || <i className="fm-text-muted">Anonym</i>}
                            {x.skattefradrag && <span className="badge badge-info" style={{ marginLeft: 6 }}>Skattefradrag</span>}
                          </td>
                          <td style={{ textAlign: 'right' }}><b>{fmt(x.belop)} {x.valuta}</b></td>
                          <td>{x.metode}</td>
                          <td>
                            {x.bilag_id > 0 && <span className="badge badge-success">Bokført</span>}
                            {x.kvittering_sendt && <span className="badge badge-info" style={{ marginLeft: 4 }}>Kvittering</span>}
                          </td>
                          <td style={{ whiteSpace: 'nowrap' }}>
                            <button className="btn btn-ghost" title="Vis kvittering" onClick={() => visKvitt(x)}><Receipt size={14} /></button>
                            {x.giver_epost && !x.anonym && (
                              <button className="btn btn-ghost" title="Send kvittering på e-post" onClick={() => sendKvitt(x)}><Mail size={14} /></button>
                            )}
                            {!x.bilag_id && (
                              <button className="btn btn-ghost" title="Bokfør" onClick={() => bokforD(x)}><FileText size={14} /></button>
                            )}
                            {x.medlem_id > 0 && x.skattefradrag && (
                              <button className="btn btn-ghost" title="Årlig skattefradragsrapport"
                                onClick={() => apneSkattefradrag(x.medlem_id)}>
                                <FileText size={14} />
                              </button>
                            )}
                            <button className="btn btn-ghost" title="Slett" onClick={() => slettD(x)}><Trash2 size={14} /></button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}
            </>
          )}
        </Card>
      </div>

      {/* Kampanje-modal */}
      <Modal
        open={openK}
        onClose={() => setOpenK(false)}
        title={redK ? 'Rediger kampanje' : 'Ny kampanje'}
        width={640}
        footer={
          <>
            <button className="btn btn-secondary" onClick={() => setOpenK(false)}>Avbryt</button>
            <button className="btn btn-primary" onClick={lagreK}>Lagre</button>
          </>
        }
      >
        <div style={{ display: 'grid', gap: 10 }}>
          <div style={{ background: '#f0f9ff', border: '1px solid #bae6fd', borderRadius: 8, padding: 10, fontSize: 13, color: '#075985', display: 'flex', gap: 8, alignItems: 'flex-start' }}>
            <Info size={16} style={{ flexShrink: 0, marginTop: 1 }} />
            <span>Tips: En god tittel og et bilde dobler konvertering. Hak av <b>Vekst-funksjoner</b> nederst for matching, team og takke-melding.</span>
          </div>
          <label>Tittel*<input className="input" value={skjemaK.tittel} onChange={(e) => setSkjemaK({ ...skjemaK, tittel: e.target.value })} /></label>
          <label>Beskrivelse<textarea className="input" rows={3} value={skjemaK.beskrivelse} onChange={(e) => setSkjemaK({ ...skjemaK, beskrivelse: e.target.value })} /></label>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: 8 }}>
            <label>Mål-beløp (kr)<input type="number" className="input" value={skjemaK.mal_belop} onChange={(e) => setSkjemaK({ ...skjemaK, mal_belop: e.target.value })} /></label>
            <label>Start<input type="date" className="input" value={skjemaK.start_dato} onChange={(e) => setSkjemaK({ ...skjemaK, start_dato: e.target.value })} /></label>
            <label>Slutt<input type="date" className="input" value={skjemaK.slutt_dato} onChange={(e) => setSkjemaK({ ...skjemaK, slutt_dato: e.target.value })} /></label>
          </div>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8 }}>
            <label>Status
              <select className="input" value={skjemaK.status} onChange={(e) => setSkjemaK({ ...skjemaK, status: e.target.value })}>
                {STATUSER.map((s) => <option key={s.v} value={s.v}>{s.t}</option>)}
              </select>
            </label>
            <label>Bokføringskonto<input className="input" value={skjemaK.konto} onChange={(e) => setSkjemaK({ ...skjemaK, konto: e.target.value })} /></label>
          </div>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8 }}>
            <label style={{ display: 'flex', flexDirection: 'column', justifyContent: 'flex-end' }}>
              <span style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                <input type="checkbox" checked={skjemaK.auto_bokfor} onChange={(e) => setSkjemaK({ ...skjemaK, auto_bokfor: e.target.checked })} />
                Auto-bokfør donasjoner
              </span>
              <small className="fm-text-muted">Lager bilag automatisk ved hver donasjon</small>
            </label>
            <label>Motkonto (valgfri)
              <input className="input" placeholder="Auto fra metode" value={skjemaK.motkonto_default}
                     onChange={(e) => setSkjemaK({ ...skjemaK, motkonto_default: e.target.value })} />
              <small className="fm-text-muted">Tomt = utled (Vipps→1925, Bank→1920, Kort→1922)</small>
            </label>
          </div>
          <label>Bilde-URL (valgfri)<input className="input" value={skjemaK.bilde_url} onChange={(e) => setSkjemaK({ ...skjemaK, bilde_url: e.target.value })} /></label>
          <label style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
            <input type="checkbox" checked={skjemaK.offentlig} onChange={(e) => setSkjemaK({ ...skjemaK, offentlig: e.target.checked })} />
            Publiser offentlig giverside (gjør tilgjengelig på <code>/gi/&lt;slug&gt;</code>)
          </label>
          {skjemaK.offentlig && (
            <label>Offentlig slug (URL)
              <input className="input" placeholder="auto fra tittel" value={skjemaK.public_slug} onChange={(e) => setSkjemaK({ ...skjemaK, public_slug: e.target.value })} />
            </label>
          )}

          {/* v34: vekst-features */}
          <div style={{ borderTop: '1px solid var(--theme-border)', paddingTop: 10, marginTop: 4 }}>
            <h4 style={{ margin: '0 0 8px', fontSize: 14 }}>Vekst-funksjoner</h4>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8 }}>
              <label>Stretch-mål (etter første mål)
                <input type="number" className="input" value={skjemaK.stretch_mal}
                  onChange={(e) => setSkjemaK({ ...skjemaK, stretch_mal: e.target.value })} />
              </label>
              <label style={{ display: 'flex', alignItems: 'center', gap: 8, marginTop: 24 }}>
                <input type="checkbox" checked={skjemaK.allow_team}
                  onChange={(e) => setSkjemaK({ ...skjemaK, allow_team: e.target.checked })} />
                Tillat peer-to-peer (team-sider)
              </label>
            </div>
            <label style={{ display: 'flex', alignItems: 'center', gap: 8, marginTop: 8 }}>
              <input type="checkbox" checked={skjemaK.matching_aktiv}
                onChange={(e) => setSkjemaK({ ...skjemaK, matching_aktiv: e.target.checked })} />
              Matching aktivt (sponsor matcher hver krone)
            </label>
            {skjemaK.matching_aktiv && (
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8, marginTop: 6 }}>
                <label>Matching makskrone
                  <input type="number" className="input" value={skjemaK.matching_max}
                    onChange={(e) => setSkjemaK({ ...skjemaK, matching_max: e.target.value })} />
                </label>
                <label>Sponsor (navn)
                  <input className="input" value={skjemaK.matching_sponsor}
                    onChange={(e) => setSkjemaK({ ...skjemaK, matching_sponsor: e.target.value })} />
                </label>
              </div>
            )}
            <label style={{ display: 'flex', alignItems: 'center', gap: 8, marginTop: 8 }}>
              <input type="checkbox" checked={skjemaK.vis_giverveggen}
                onChange={(e) => setSkjemaK({ ...skjemaK, vis_giverveggen: e.target.checked })} />
              Vis giverveggen offentlig
            </label>
            <label>Slack/Discord webhook (valgfri)
              <input className="input" placeholder="https://hooks.slack.com/..."
                value={skjemaK.slack_webhook}
                onChange={(e) => setSkjemaK({ ...skjemaK, slack_webhook: e.target.value })} />
            </label>
            <label>Takke-melding (vises etter donasjon)
              <textarea className="input" rows={2} value={skjemaK.takke_melding}
                onChange={(e) => setSkjemaK({ ...skjemaK, takke_melding: e.target.value })} />
              <button type="button" className="btn btn-secondary" style={{ marginTop: 4 }}
                disabled={aiBusy} onClick={aiForslagTakk}>
                <Sparkles size={14} /> {aiBusy ? 'AI tenker…' : 'AI-forslag'}
              </button>
            </label>
          </div>

          {/* v35: Tillit & transparens */}
          <div style={{ borderTop: '1px solid var(--border)', paddingTop: 10, marginTop: 8 }}>
            <h4 style={{ margin: '0 0 8px' }}>Tillit & transparens</h4>
            <label style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
              <input type="checkbox" checked={!!skjemaK.verifisert}
                onChange={(e) => setSkjemaK({ ...skjemaK, verifisert: e.target.checked })} />
              Verifisert organisasjon (viser badge på giverside)
            </label>
            <label style={{ display: 'flex', alignItems: 'center', gap: 8, marginTop: 4 }}>
              <input type="checkbox" checked={!!skjemaK.innsamlingskontrollen}
                onChange={(e) => setSkjemaK({ ...skjemaK, innsamlingskontrollen: e.target.checked })} />
              Medlem av Innsamlingskontrollen
            </label>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 2fr', gap: 8, marginTop: 8 }}>
              <label>Org.nr<input className="input" value={skjemaK.orgnr || ''}
                onChange={(e) => setSkjemaK({ ...skjemaK, orgnr: e.target.value })} /></label>
              <label>Transparens-rapport URL
                <input className="input" placeholder="https://..." value={skjemaK.transparens_url || ''}
                  onChange={(e) => setSkjemaK({ ...skjemaK, transparens_url: e.target.value })} />
              </label>
            </div>
          </div>

          {/* v35: Innhold */}
          <div style={{ borderTop: '1px solid var(--border)', paddingTop: 10, marginTop: 4 }}>
            <h4 style={{ margin: '0 0 8px' }}>Innhold</h4>
            <label>Video-URL (YouTube/Vimeo embed eller mp4)
              <input className="input" placeholder="https://www.youtube.com/embed/..."
                value={skjemaK.video_url || ''}
                onChange={(e) => setSkjemaK({ ...skjemaK, video_url: e.target.value })} />
            </label>
            <label style={{ marginTop: 6 }}>Ekstra bilder (én URL per linje)
              <textarea className="input" rows={3}
                placeholder="https://.../bilde1.jpg&#10;https://.../bilde2.jpg"
                value={skjemaK.bilder_extra || ''}
                onChange={(e) => setSkjemaK({ ...skjemaK, bilder_extra: e.target.value })} />
            </label>
          </div>

          {/* v41: Vipps-nummer (enkel vei) */}
          <div style={{ borderTop: '1px solid var(--border)', paddingTop: 10, marginTop: 4 }}>
            <h4 style={{ margin: '0 0 8px', display: 'flex', alignItems: 'center', gap: 6 }}><Gift size={16} /> Vipps-nummer (enkel vei)</h4>
            <label>Vipps-nummer
              <input className="input" value={skjemaK.vipps_nummer || ''}
                placeholder="f.eks. 12345"
                onChange={(e) => setSkjemaK({ ...skjemaK, vipps_nummer: e.target.value })} />
            </label>
            <p className="fm-text-muted" style={{ fontSize: 11, margin: '4px 0 0' }}>
              Har foreningen et Vipps-nummer (Vipps til veldedige organisasjoner)? Legg det inn her,
              så vises det stort på giversiden og på QR-plakaten. Da kan givere vippse direkte uten
              at du trenger Vipps API-avtale. Donasjoner via nummeret må du registrere/importere selv.
            </p>
          </div>

          {/* v35: Bursdagsmodus */}
          <div style={{ borderTop: '1px solid var(--border)', paddingTop: 10, marginTop: 4 }}>
            <h4 style={{ margin: '0 0 8px', display: 'flex', alignItems: 'center', gap: 6 }}><Cake size={16} /> Bursdagsmodus</h4>
            <label style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
              <input type="checkbox" checked={!!skjemaK.bursdag_modus}
                onChange={(e) => setSkjemaK({ ...skjemaK, bursdag_modus: e.target.checked })} />
              Aktiver bursdagsmodus (gaver i stedet for tradisjonell gave)
            </label>
            {skjemaK.bursdag_modus && (
              <div style={{ display: 'grid', gridTemplateColumns: '2fr 1fr', gap: 8, marginTop: 6 }}>
                <label>Navn på bursdagsbarn
                  <input className="input" value={skjemaK.bursdag_navn || ''}
                    onChange={(e) => setSkjemaK({ ...skjemaK, bursdag_navn: e.target.value })} />
                </label>
                <label>Dato
                  <input type="date" className="input" value={skjemaK.bursdag_dato || ''}
                    onChange={(e) => setSkjemaK({ ...skjemaK, bursdag_dato: e.target.value })} />
                </label>
              </div>
            )}
          </div>

          <label>Internt notat<textarea className="input" rows={2} value={skjemaK.notat} onChange={(e) => setSkjemaK({ ...skjemaK, notat: e.target.value })} /></label>
        </div>
      </Modal>

      {/* Donasjon-modal */}
      <Modal
        open={openD}
        onClose={() => setOpenD(false)}
        title="Registrer donasjon"
        width={560}
        footer={
          <>
            <button className="btn btn-secondary" onClick={() => setOpenD(false)}>Avbryt</button>
            <button className="btn btn-primary" onClick={lagreD}>Lagre</button>
          </>
        }
      >
        <div style={{ display: 'grid', gap: 10 }}>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8 }}>
            <label>Dato<input type="date" className="input" value={skjemaD.dato} onChange={(e) => setSkjemaD({ ...skjemaD, dato: e.target.value })} /></label>
            <label>Beløp (kr)*<input type="number" className="input" value={skjemaD.belop} onChange={(e) => setSkjemaD({ ...skjemaD, belop: e.target.value })} /></label>
          </div>
          <label style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
            <input type="checkbox" checked={skjemaD.anonym} onChange={(e) => setSkjemaD({ ...skjemaD, anonym: e.target.checked })} />
            Anonym donasjon
          </label>
          {!skjemaD.anonym && (
            <>
              {medlemmer.length > 0 && (
                <label>Velg eksisterende medlem (valgfri)
                  <select className="input" value={skjemaD.medlem_id || ''} onChange={(e) => valgMedlem(e.target.value)}>
                    <option value="">— Manuell registrering —</option>
                    {medlemmer.map((m) => (
                      <option key={m.id} value={m.id}>{m.navn}{m.medlemsnr ? ` (#${m.medlemsnr})` : ''}</option>
                    ))}
                  </select>
                </label>
              )}
              <label>Giverens navn<input className="input" value={skjemaD.giver_navn} onChange={(e) => setSkjemaD({ ...skjemaD, giver_navn: e.target.value })} /></label>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8 }}>
                <label>E-post<input className="input" value={skjemaD.giver_epost} onChange={(e) => setSkjemaD({ ...skjemaD, giver_epost: e.target.value })} /></label>
                <label>Telefon<input className="input" value={skjemaD.giver_telefon} onChange={(e) => setSkjemaD({ ...skjemaD, giver_telefon: e.target.value })} /></label>
              </div>
              <label style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                <input type="checkbox" checked={skjemaD.skattefradrag} onChange={(e) => setSkjemaD({ ...skjemaD, skattefradrag: e.target.checked })} />
                Skal innrapporteres for skattefradrag
              </label>
              {skjemaD.skattefradrag && (
                <label>Fødselsnummer (11 siffer)
                  <input className="input" maxLength={11} value={skjemaD.giver_fnr} onChange={(e) => setSkjemaD({ ...skjemaD, giver_fnr: e.target.value })} />
                </label>
              )}
            </>
          )}
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8 }}>
            <label>Betalingsmetode
              <select className="input" value={skjemaD.metode} onChange={(e) => setSkjemaD({ ...skjemaD, metode: e.target.value })}>
                <option value="manuell">Manuell</option>
                <option value="vipps">Vipps</option>
                <option value="kort">Kort</option>
                <option value="bank">Bank</option>
                <option value="kontant">Kontant</option>
              </select>
            </label>
            <label>Frekvens
              <select className="input" value={skjemaD.frekvens} onChange={(e) => setSkjemaD({ ...skjemaD, frekvens: e.target.value })}>
                <option value="engangs">Engangs</option>
                <option value="maaned">Månedlig (fast)</option>
                <option value="aar">Årlig (fast)</option>
              </select>
            </label>
          </div>
          <label>Referanse (valgfri)<input className="input" value={skjemaD.referanse} onChange={(e) => setSkjemaD({ ...skjemaD, referanse: e.target.value })} /></label>
          <details>
            <summary style={{ cursor: 'pointer', fontSize: 13, color: 'var(--theme-text-muted)' }}>
              <Gift size={12} style={{ verticalAlign: 'middle' }} /> Gi på vegne av noen (valgfritt)
            </summary>
            <div style={{ display: 'grid', gap: 6, marginTop: 8 }}>
              <label>Mottakerens navn
                <input className="input" value={skjemaD.gave_navn}
                  onChange={(e) => setSkjemaD({ ...skjemaD, gave_navn: e.target.value })} />
              </label>
              <label>Hilsen til mottaker
                <textarea className="input" rows={2} value={skjemaD.gave_melding}
                  onChange={(e) => setSkjemaD({ ...skjemaD, gave_melding: e.target.value })} />
              </label>
            </div>
          </details>
          <label>Hilsen / melding<textarea className="input" rows={2} value={skjemaD.melding} onChange={(e) => setSkjemaD({ ...skjemaD, melding: e.target.value })} /></label>
        </div>
      </Modal>

      {/* Team-modal */}
      <Modal
        open={openTeam}
        onClose={() => setOpenTeam(false)}
        title={redTeam ? 'Rediger team' : 'Nytt team'}
        width={520}
        footer={
          <>
            <button className="btn btn-secondary" onClick={() => setOpenTeam(false)}>Avbryt</button>
            <button className="btn btn-primary" onClick={lagreTeam}>Lagre</button>
          </>
        }
      >
        <div style={{ display: 'grid', gap: 10 }}>
          <label>Navn*<input className="input" value={skjemaTeam.navn}
            onChange={(e) => setSkjemaTeam({ ...skjemaTeam, navn: e.target.value })} /></label>
          <label>Beskrivelse<textarea className="input" rows={2} value={skjemaTeam.beskrivelse}
            onChange={(e) => setSkjemaTeam({ ...skjemaTeam, beskrivelse: e.target.value })} /></label>
          <label>Mål (kr)<input type="number" className="input" value={skjemaTeam.mal_belop}
            onChange={(e) => setSkjemaTeam({ ...skjemaTeam, mal_belop: e.target.value })} /></label>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8 }}>
            <label>Eier navn<input className="input" value={skjemaTeam.eier_navn}
              onChange={(e) => setSkjemaTeam({ ...skjemaTeam, eier_navn: e.target.value })} /></label>
            <label>Eier e-post<input className="input" value={skjemaTeam.eier_epost}
              onChange={(e) => setSkjemaTeam({ ...skjemaTeam, eier_epost: e.target.value })} /></label>
          </div>
          <label>Bilde-URL<input className="input" value={skjemaTeam.bilde_url}
            onChange={(e) => setSkjemaTeam({ ...skjemaTeam, bilde_url: e.target.value })} /></label>
        </div>
      </Modal>

      {/* Mail-kampanje */}
      <Modal
        open={openMail}
        onClose={() => setOpenMail(false)}
        title="E-postkampanje til medlemmer"
        width={560}
        footer={
          <>
            <button className="btn btn-secondary" onClick={() => setOpenMail(false)}>Avbryt</button>
            <button className="btn btn-secondary" onClick={() => sendMail(true)}>Send test</button>
            <button className="btn btn-primary" onClick={() => sendMail(false)}>Send til alle</button>
          </>
        }
      >
        <div style={{ display: 'grid', gap: 10 }}>
          <p className="fm-text-muted" style={{ fontSize: 13 }}>
            Sendes til alle aktive medlemmer som har samtykket til kommunikasjon.
            Lenken til giversiden legges automatisk inn.
          </p>
          <label>Emne*<input className="input" value={skjemaMail.emne}
            onChange={(e) => setSkjemaMail({ ...skjemaMail, emne: e.target.value })} /></label>
          <label>Melding* (HTML eller ren tekst)
            <textarea className="input" rows={8} value={skjemaMail.melding}
              onChange={(e) => setSkjemaMail({ ...skjemaMail, melding: e.target.value })} />
          </label>
          <label>Test-mottaker (for «Send test»)
            <input className="input" type="email" placeholder="din@epost.no" value={skjemaMail.test_til}
              onChange={(e) => setSkjemaMail({ ...skjemaMail, test_til: e.target.value })} />
          </label>
        </div>
      </Modal>

      {/* Dashboard-modal */}
      <Modal
        open={openDash}
        onClose={() => setOpenDash(false)}
        title={`Giver-dashboard ${dash?.aar || ''}`}
        width={720}
        footer={
          <button className="btn btn-primary" onClick={() => setOpenDash(false)}>Lukk</button>
        }
      >
        {dash && (
          <div style={{ display: 'grid', gap: 12 }}>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: 8 }}>
              <StatCard label="Sum året" value={`${fmt(dash.sum_aar)} kr`} icon={TrendingUp} />
              <StatCard label="Antall donasjoner" value={dash.antall_donasjoner} icon={Gift} />
              <StatCard label="Unike givere" value={dash.antall_givere} icon={Users} />
              <StatCard label="Snitt-donasjon" value={`${fmt(dash.snitt)} kr`} icon={Target} />
            </div>
            <div>
              <h4 style={{ margin: '8px 0' }}>Per måned</h4>
              <div style={{ display: 'flex', gap: 3, alignItems: 'flex-end', height: 80 }}>
                {dash.per_mnd.map((v, i) => {
                  const maks = Math.max(...dash.per_mnd, 1);
                  return (
                    <div key={i} style={{ flex: 1, textAlign: 'center', fontSize: 10 }}>
                      <div style={{ height: `${(v / maks) * 70}px`, background: 'var(--theme-accent)', borderRadius: 4, marginBottom: 4 }}
                           title={`${fmt(v)} kr`} />
                      {['J', 'F', 'M', 'A', 'M', 'J', 'J', 'A', 'S', 'O', 'N', 'D'][i]}
                    </div>
                  );
                })}
              </div>
            </div>
            {dash.topp_givere.length > 0 && (
              <div>
                <h4 style={{ margin: '8px 0' }}>Topp 10 givere</h4>
                <table className="fm-table">
                  <thead><tr><th>Navn</th><th style={{ textAlign: 'right' }}>Antall</th><th style={{ textAlign: 'right' }}>Sum</th></tr></thead>
                  <tbody>
                    {dash.topp_givere.map((g, i) => (
                      <tr key={i}>
                        <td>{g.navn || <i>Ukjent</i>}</td>
                        <td style={{ textAlign: 'right' }}>{g.antall}</td>
                        <td style={{ textAlign: 'right' }}><b>{fmt(g.sum)} kr</b></td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8, fontSize: 13 }}>
              <div>Faste givere: <b>{dash.faste_givere}</b></div>
              <div>Anonym andel: <b>{fmt(dash.anonym_sum)} kr</b></div>
            </div>
          </div>
        )}
      </Modal>

      {/* Veileder-modal */}
      <Modal
        open={openVeileder}
        onClose={() => setOpenVeileder(false)}
        title="Veileder – Innsamling & fundraising"
        width={680}
        footer={<button className="btn btn-primary" onClick={() => setOpenVeileder(false)}>Lukk</button>}
      >
        <div style={{ fontSize: 14, lineHeight: 1.55 }}>
          <h4 style={{ margin: '0 0 6px', display: 'flex', alignItems: 'center', gap: 6 }}><Target size={16} /> 1. Lag en sterk kampanje</h4>
          <ul style={{ marginTop: 4 }}>
            <li><b>Tittel</b>: Konkret og emosjonell – «Hjelp Lina til skolestart» slår «Innsamling 2026».</li>
            <li><b>Beskrivelse</b>: 2–4 setninger. Hva trengs, hvem hjelpes, hva skjer hvis du gir?</li>
            <li><b>Bilde-URL</b>: Last opp i Bilder/CDN og lim inn. Bilder dobler konvertering.</li>
            <li><b>Mål-beløp</b>: Sett realistisk – fremdriftslinjen motiverer mest når den fylles.</li>
          </ul>

          <h4 style={{ margin: '12px 0 6px', display: 'flex', alignItems: 'center', gap: 6 }}><Rocket size={16} /> 2. Slå på vekst-funksjoner</h4>
          <ul style={{ marginTop: 4 }}>
            <li><b>Stretch-mål</b>: Når hovedmålet nås, vises et nytt mål automatisk – holder kampanjen levende.</li>
            <li><b>Matching</b>: Sponsor dobler hver krone. «Hver krone telles 2×!» øker engangsbeløpet ~40 %.</li>
            <li><b>Tillat team</b>: Givere kan samle inn på vegne av kampanjen. Klassisk peer-to-peer.</li>
            <li><b>Takke-melding</b>: Personlig hilsen vises etter donasjon – mye bedre enn standard.</li>
            <li><b>Slack/Discord-webhook</b>: Få ping i kanalen ved hver gave – team-motivasjon i sanntid.</li>
          </ul>

          <h4 style={{ margin: '12px 0 6px', display: 'flex', alignItems: 'center', gap: 6 }}><Megaphone size={16} /> 3. Promoter giversiden</h4>
          <ul style={{ marginTop: 4 }}>
            <li><b>QR-plakat</b>: Print A4 til kirkekaffe, stand, konsert. Folk skanner med mobilen.</li>
            <li><b>Embed-widget</b>: Lim inn på egne nettsider – progress-bar oppdateres live.</li>
            <li><b>Del-lenke (OG)</b>: Bruk denne på Facebook/LinkedIn for fin forhåndsvisning.</li>
            <li><b>E-postkampanje</b>: Send invitasjon til medlemmer med samtykke. Test først!</li>
            <li><b>Facebook-knapp</b>: Vises automatisk etter donasjon – givere blir ambassadører.</li>
          </ul>

          <h4 style={{ margin: '12px 0 6px', display: 'flex', alignItems: 'center', gap: 6 }}><Wallet size={16} /> 4. Hold orden i regnskapet</h4>
          <ul style={{ marginTop: 4 }}>
            <li><b>Auto-bokfør</b>: Hver donasjon lager bilag mot konto 3440 (innsamlede midler).</li>
            <li><b>Skattefradrag</b>: Hak av per donasjon (krever fnr). Eksporter <b>gaverapport CSV</b> for Skatteetaten i januar.</li>
            <li><b>Innsamlingskontrollen</b>: Sjekk at minst 65 % går til formålet – generer rapport her.</li>
            <li><b>Dashboard</b>: Se topp-givere, månedstrend og faste givere.</li>
          </ul>

          <h4 style={{ margin: '12px 0 6px', display: 'flex', alignItems: 'center', gap: 6 }}><Lightbulb size={16} /> Beste praksis</h4>
          <ul style={{ marginTop: 4 }}>
            <li>Send takk-mail innen 24 timer (skjer automatisk via kvittering).</li>
            <li>Del milepæler: 25 %, 50 %, 75 %, nådd mål – det skaper momentum.</li>
            <li>Vis ekte ansikter og historier. Anonym statistikk overbeviser ikke.</li>
            <li>Pin en stor donasjon eller utfordring: «Gi 500 kr så matcher vi opp til 50 000».</li>
          </ul>
        </div>
      </Modal>

      {/* Kollekt-modal */}
      <Modal open={openKollekt} onClose={() => setOpenKollekt(false)}
        title="Registrer kollekt / spontan innsamling" width={560}
        footer={<>
          <button className="btn btn-secondary" onClick={() => setOpenKollekt(false)}>Avbryt</button>
          <button className="btn btn-primary" onClick={lagreKollekt} disabled={kollektBusy}>
            {kollektBusy ? 'Lagrer…' : 'Registrer og bokfør'}
          </button>
        </>}>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10 }}>
          <label>Dato
            <input type="date" className="input" value={skjemaKollekt.dato}
              onChange={(e) => setSkjemaKollekt({ ...skjemaKollekt, dato: e.target.value })} />
          </label>
          <label>Beløp (kr)
            <input type="number" className="input" value={skjemaKollekt.belop}
              disabled={skjemaKollekt.bruk_spesifikasjon}
              onChange={(e) => setSkjemaKollekt({ ...skjemaKollekt, belop: e.target.value })}
              placeholder={skjemaKollekt.bruk_spesifikasjon ? 'Fra opptelling' : '0'} />
          </label>
          <label style={{ gridColumn: '1 / -1' }}>Formål / anledning*
            <input className="input" value={skjemaKollekt.formaal}
              placeholder="f.eks. Kollekt gudstjeneste 13.07, eller innsamling til …"
              onChange={(e) => setSkjemaKollekt({ ...skjemaKollekt, formaal: e.target.value })} />
          </label>
          <label>Teller 1 (navn)*
            <input className="input" value={skjemaKollekt.teller1_navn}
              onChange={(e) => setSkjemaKollekt({ ...skjemaKollekt, teller1_navn: e.target.value })} />
          </label>
          <label>Teller 2 (navn)*
            <input className="input" value={skjemaKollekt.teller2_navn}
              onChange={(e) => setSkjemaKollekt({ ...skjemaKollekt, teller2_navn: e.target.value })} />
          </label>
        </div>

        <label style={{ display: 'flex', alignItems: 'center', gap: 8, marginTop: 12 }}>
          <input type="checkbox" checked={skjemaKollekt.bruk_spesifikasjon}
            onChange={(e) => setSkjemaKollekt({ ...skjemaKollekt, bruk_spesifikasjon: e.target.checked })} />
          Tell opp sedler og mynt (kontantspesifikasjon)
        </label>

        {skjemaKollekt.bruk_spesifikasjon && (
          <div style={{ marginTop: 8, padding: 10, background: 'var(--theme-bg-soft)', borderRadius: 8 }}>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 8 }}>
              {SEDLER_MYNT.map((d) => (
                <label key={d} style={{ fontSize: 11 }}>{d} kr
                  <input type="number" min="0" className="input"
                    value={skjemaKollekt.spesifikasjon[d]}
                    onChange={(e) => setSkjemaKollekt({
                      ...skjemaKollekt,
                      spesifikasjon: { ...skjemaKollekt.spesifikasjon, [d]: e.target.value },
                    })} />
                </label>
              ))}
            </div>
            <div style={{ textAlign: 'right', marginTop: 8, fontWeight: 700 }}>
              Sum opptalt: {fmt(spesSum(skjemaKollekt.spesifikasjon))} kr
            </div>
          </div>
        )}

        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10, marginTop: 10 }}>
          <label>Inntektskonto
            <input className="input" value={skjemaKollekt.konto}
              onChange={(e) => setSkjemaKollekt({ ...skjemaKollekt, konto: e.target.value })} />
          </label>
          <label>Motkonto (Kasse/bank)
            <input className="input" value={skjemaKollekt.motkonto}
              onChange={(e) => setSkjemaKollekt({ ...skjemaKollekt, motkonto: e.target.value })} />
          </label>
          <label style={{ gridColumn: '1 / -1' }}>Notat (valgfritt)
            <input className="input" value={skjemaKollekt.notat}
              onChange={(e) => setSkjemaKollekt({ ...skjemaKollekt, notat: e.target.value })} />
          </label>
        </div>
        <p className="fm-text-muted" style={{ fontSize: 11, marginTop: 8 }}>
          Ved lagring opprettes et bilag automatisk: debet <b>{skjemaKollekt.motkonto}</b> (kontanter),
          kredit <b>{skjemaKollekt.konto}</b> (innsamlingsinntekt). Begge tellere lagres for sporbarhet.
        </p>
      </Modal>

      {/* v35: Oppdaterings-modal */}
      <Modal open={openOppd} onClose={() => setOpenOppd(false)}
        title={redOppd ? 'Rediger oppdatering' : 'Ny oppdatering'} width={520}
        footer={<>
          <button className="btn btn-secondary" onClick={() => setOpenOppd(false)}>Avbryt</button>
          <button className="btn btn-primary" onClick={lagreOppd}>Lagre</button>
        </>}>
        <div style={{ display: 'grid', gap: 10 }}>
          <label>Tittel*<input className="input" value={skjemaOppd.tittel}
            onChange={(e) => setSkjemaOppd({ ...skjemaOppd, tittel: e.target.value })} /></label>
          <label>Tekst<textarea className="input" rows={4} value={skjemaOppd.tekst}
            onChange={(e) => setSkjemaOppd({ ...skjemaOppd, tekst: e.target.value })} /></label>
          <label>Bilde-URL (valgfritt)<input className="input" value={skjemaOppd.bilde_url}
            onChange={(e) => setSkjemaOppd({ ...skjemaOppd, bilde_url: e.target.value })} /></label>
        </div>
      </Modal>

      {/* v35: Testimonial-modal */}
      <Modal open={openTesti} onClose={() => setOpenTesti(false)}
        title={redTesti ? 'Rediger sitat' : 'Nytt sitat'} width={520}
        footer={<>
          <button className="btn btn-secondary" onClick={() => setOpenTesti(false)}>Avbryt</button>
          <button className="btn btn-primary" onClick={lagreTesti}>Lagre</button>
        </>}>
        <div style={{ display: 'grid', gap: 10 }}>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8 }}>
            <label>Navn<input className="input" value={skjemaTesti.navn}
              onChange={(e) => setSkjemaTesti({ ...skjemaTesti, navn: e.target.value })} /></label>
            <label>Rolle<input className="input" placeholder="f.eks. tidligere giver"
              value={skjemaTesti.rolle}
              onChange={(e) => setSkjemaTesti({ ...skjemaTesti, rolle: e.target.value })} /></label>
          </div>
          <label>Sitat*<textarea className="input" rows={3} value={skjemaTesti.sitat}
            onChange={(e) => setSkjemaTesti({ ...skjemaTesti, sitat: e.target.value })} /></label>
          <label>Bilde-URL (valgfritt)<input className="input" value={skjemaTesti.bilde_url}
            onChange={(e) => setSkjemaTesti({ ...skjemaTesti, bilde_url: e.target.value })} /></label>
        </div>
      </Modal>

      {/* v35: Partner-modal */}
      <Modal open={openPartner} onClose={() => setOpenPartner(false)}
        title={redPartner ? 'Rediger partner' : 'Ny partner'} width={520}
        footer={<>
          <button className="btn btn-secondary" onClick={() => setOpenPartner(false)}>Avbryt</button>
          <button className="btn btn-primary" onClick={lagrePartner}>Lagre</button>
        </>}>
        <div style={{ display: 'grid', gap: 10 }}>
          <label>Navn*<input className="input" value={skjemaPartner.navn}
            onChange={(e) => setSkjemaPartner({ ...skjemaPartner, navn: e.target.value })} /></label>
          <label>Logo-URL<input className="input" value={skjemaPartner.logo_url}
            onChange={(e) => setSkjemaPartner({ ...skjemaPartner, logo_url: e.target.value })} /></label>
          <label>Lenke<input className="input" placeholder="https://..." value={skjemaPartner.lenke}
            onChange={(e) => setSkjemaPartner({ ...skjemaPartner, lenke: e.target.value })} /></label>
          <label>Donert beløp (kr)<input type="number" className="input" value={skjemaPartner.belop}
            onChange={(e) => setSkjemaPartner({ ...skjemaPartner, belop: e.target.value })} /></label>
        </div>
      </Modal>
    </>
  );
};

export default Innsamling;
